module.exports = __webpack_public_path__ + "static/media/bolster-awareness-icon.82eae910.svg";